export const PLAYBACK_SPEEDS = [
  0.25, 0.5, 0.75, 1, 1.25, 1.5, 2, 4, 8, 10, 12, 14, 16,
];
export const FRAME_STEP_SECONDS = 1;
export const SKIP_BUTTON_SECONDS = 15;
export const DIALOG_SKIP_BUTTON_SECONDS = 5;
export const DIALOG_KEYBOARD_SEEK_STEP_SECONDS = 1;
export const DEFAULT_KEYBOARD_SEEK = { stepSeconds: 10 } as const;
export const PLAYBACK_SCOPE = "playback";
export const DEFAULT_VIDEO_ASPECT_RATIO = 4 / 3;

export const GOVERNOR_TICK_MS = 100;
export const GOVERNOR_MAX_TICK_SECONDS = 0.5; // bounds the clock jump after a backgrounded tab
export const PREROLL_CUSHION_WALL_SECONDS = 2.0;
export const REBUFFER_HOLD_WALL_SECONDS = 0.5; // < cushion; the gap is the anti-flap hysteresis band
export const HARD_SEEK_DRIFT_SECONDS = 1.0;
export const DEAD_TILE_TIMEOUT_SECONDS = 12;
export const REGISTRATION_SETTLE_MS = 500;
export const HIDDEN_TAB_SUSPEND_DELAY_MS = 60_000;
export const CLOCK_MIRROR_INTERVAL_MS = 250;
export const CLOCK_MIRROR_THRESHOLD_SECONDS = 0.05;
export const BUFFERED_TO_END_TOLERANCE_SECONDS = 0.5;
export const PLAYBACK_RATE_EPSILON = 0.01;

export interface VideoBufferBudget {
  /** Also a buffer-length floor in hls.js: 8 × bytes ÷ bitrate seconds. */
  maxBufferSizeBytes: number;
  baseBufferLengthSeconds: number;
  maxBufferLengthSeconds: number;
}

export const NORMAL_VIDEO_BUFFER_BUDGET: VideoBufferBudget = {
  maxBufferSizeBytes: 100 * 1000 * 1000,
  baseBufferLengthSeconds: 120,
  maxBufferLengthSeconds: 600,
};

export const LOW_MEMORY_VIDEO_BUFFER_BUDGET: VideoBufferBudget = {
  maxBufferSizeBytes: 20 * 1000 * 1000,
  baseBufferLengthSeconds: 30,
  maxBufferLengthSeconds: 120,
};
